// An expired session reaches /login the same way a deliberate logout does: vue-auth signs out and
// pushes /login. Only the expiry starts with a 401 on a signed-in token (clearOnUnauthorized), so
// that moment is recorded here, and the router returns to the page only right after one.
const WINDOW_MS = 10_000;
let expiredAt = 0;

export function markSessionExpired() {
  expiredAt = Date.now();
}

// True once per expiry, and only shortly after it: a stale mark must not send the next
// person who signs in to the previous user's page.
export function takeSessionExpired() {
  const expired = Date.now() - expiredAt < WINDOW_MS;
  expiredAt = 0;
  return expired;
}
